// extracted by mini-css-extract-plugin
export default {"text":"DeleteSavedAddressModal-module__text"};